'use client';

import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { type FAQItem } from '../lib/variants';

interface FAQProps {
  questions: FAQItem[];
}

const FAQ: React.FC<FAQProps> = ({ questions: faqItems }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Najczęstsze pytania
          </h2>
          <p className="mt-4 text-xl text-gray-500">
            Masz wątpliwości? Odpowiadamy.
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((q, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:border-cyan-200 transition">
              <button
                className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                <span className="font-semibold text-gray-900 text-base">{q.question}</span>
                {openIndex === index ? (
                  <Minus className="h-5 w-5 text-cyan-600 flex-shrink-0 ml-4" />
                ) : (
                  <Plus className="h-5 w-5 text-gray-400 flex-shrink-0 ml-4" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6 pt-0">
                  <div className="h-px bg-gray-100 mb-4" />
                  <p className="text-gray-600 leading-relaxed">{q.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
